<form #thisForm="ngForm" (ngSubmit)="submit()">
  <h3>Upload de Carga</h3>
  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados do arquivo de upload</div>
    <div class="row mb-2">
      <label class="col-4">
        <ng-select
          style="width: 250px"
          data-cy="loadTypesId"
          name="loadTypesId"
          placeholder="Tipo de Carga"
          [(ngModel)]="model.loadTypesId"
        >
          <ng-option [value]="1">Fundo</ng-option>
          <ng-option [value]="2">Gestor</ng-option>
          <ng-option [value]="3">Contas Fundo</ng-option>
          <ng-option [value]="4">Fundo Investido</ng-option>
          <ng-option [value]="6">Lastro</ng-option>
        </ng-select>
      </label>
    </div>

    <div class="card-body">
      <div class="row mb-2">
        <div class="col-12" actions>
          Arquivo
          <input
            type="file"
            name="file"
            data-cy="uploadFile"
            (change)="openFile($event)"
          />
        </div>
      </div>
      <div class="actions">
        <input
          type="button"
          value="Baixar Template"
          data-cy="submit"
          class="btn btn-primary me-2"
          [disabled]="model.loadTypesId === null"
          appDebounceClick
          (debounceClick)="downloadTemplate()"
          [debounceTime]="200"
        />
        <input
          type="button"
          value="Upload"
          data-cy="submit"
          class="btn btn-primary me-2"
          [disabled]="model.loadTypesId === null || file == null"
          appDebounceClick
          (debounceClick)="submit()"
          [debounceTime]="200"
        />
      </div>
    </div>
  </div>
</form>
<tabela-historico-carga></tabela-historico-carga>
